import { Link } from "react-router-dom";
import { ArrowLeft, HardHat, PhoneCall } from "lucide-react";

export default function ArticlePage() {
  return (
    <main className="bg-white">
      <div className="container mx-auto px-6 py-24">
        <div
          data-testid="article-under-construction"
          className="max-w-2xl mx-auto border border-amber-300 bg-amber-50 p-10 text-center flex flex-col items-center gap-5"
        >
          <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center">
            <HardHat className="w-7 h-7 text-amber-600" />
          </div>
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-amber-700">Under Construction</div>
          <h2 className="font-display font-black text-2xl sm:text-3xl text-zinc-950 tracking-tight">
            This guide is temporarily offline.
          </h2>
          <p className="text-zinc-700 leading-relaxed max-w-md">
            We're updating our troubleshooting guides and they'll be back soon. In the meantime, if something's not right with your van, leave us a request and a technician will take a look and get back to you.
          </p>
          <Link
            to="/request"
            data-testid="article-request-btn"
            className="mt-2 inline-flex items-center gap-2 bg-[#16A34A] text-white px-6 py-3 font-semibold hover:bg-[#15803D] transition-colors"
          >
            <PhoneCall className="w-4 h-4" /> Request a Service or Call Back
          </Link>
          <Link to="/troubleshooting" data-testid="back-to-troubleshooting" className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-zinc-950 transition-colors">
            <ArrowLeft className="w-4 h-4" /> Back
          </Link>
        </div>
      </div>
    </main>
  );
}
